import isPlainObject from 'lodash/isPlainObject';
import isArray from 'lodash/isArray';

export function underscoreString(str) {
    return str.replace(/([A-Z])/g, s => `_${s.toLowerCase()}`);
}

export default function camelCase(obj) {
    if (isArray(obj)) {
        return obj.map(item => camelCase(item));
    }

    if (!isPlainObject(obj)) return obj;

    return Object.keys(obj).reduce((result, key) => {
        result[underscoreString(key)] = isPlainObject(obj[key]) || isArray(obj[key])
            ? camelCase(obj[key])
            : obj[key];
        return result;
    }, {});
}
